import React, { useEffect, useRef, useState } from 'react';
import './education.css';

const EDUCATION = [
  {
    id: 'beng',
    degree: 'Bachelor of Engineering (B.Eng.)',
    field: 'Environmental Engineering',
    institution: 'University of Guelph',
    icon: '\u25C6', // ◆
  },
  {
    id: 'obc',
    degree: 'Part 8 OBC Certificate',
    field: 'On-Site Sewage Systems Inspector / Installer',
    institution: 'University of Guelph',
    icon: '\u25C7', // ◇
  },
];

export const Education = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="Education"
      className={`education-section ${visible ? 'visible' : ''}`}
      ref={ref}
      aria-label="Education & Certifications"
    >
      <div className="container">
        <div className="section-header">
          <h2>EDUCATION &amp; CERTIFICATIONS</h2>
        </div>

        <div className="edu-grid">
          {EDUCATION.map((edu, idx) => (
            <div
              key={edu.id}
              className="terminal-window edu-card"
              style={{ animationDelay: `${idx * 0.15}s` }}
            >
              <div className="terminal-header">
                <div className="dots">
                  <span className="dot active"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
                <span>credentials/{edu.id}.cert</span>
              </div>
              <div className="terminal-body edu-body">
                <div className="edu-icon">{edu.icon}</div>
                <h3 className="edu-degree">{edu.degree}</h3>
                <div className="edu-field">{edu.field}</div>
                <div className="edu-inst">{edu.institution}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
